export default {
  api_url: 'https://tracker2.rocket-lab.ru/api',
  dev_url: 'https://tracker-dev.rocket-lab.ru/api',
  dev_auth_url: 'https://tracker-dev.rocket-lab.ru/token',
  auth_url: 'https://tracker2.rocket-lab.ru/token',
  field_dev: 'https://tracker-dev.rocket-lab.ru/field',
  field: 'https://tracker2.rocket-lab.ru/field',
  site_url: 'https://tracker2.rocket-lab.ru',
  dev_site_url: 'https://tracker-dev.rocket-lab.ru',
  mode: process.env.NODE_ENV === 'production' ? 'prod' : 'dev'
}